import { useTranslation } from 'gatsby-plugin-react-i18next';
import React from 'react';
import { useForm } from 'react-hook-form';
import FormText from '../../../components/FormText/FormText';
import { FORM_TEXT_COMPONENT_TYPES, FORM_TEXT_TYPES } from '../../../components/FormText/types';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';

const FormAddPetName = () => {
  const { t } = useTranslation();
  const { register, handleSubmit, reset, formState } = useForm();
  const newPet = vars.newPet();
  const type = FORM_TEXT_TYPES.CREATE_PET;
  const { registerAs } = FORM_TEXT_COMPONENT_TYPES[type];
  const petTypeTranslation = t(`formChoiceTypes.${newPet?.type?.toLowerCase()}.${newPet?.type?.toLowerCase()}Option`);
  const title = t(FORM_TEXT_COMPONENT_TYPES[type].title, {
    petType: petTypeTranslation
  });
  const placeholder = t(FORM_TEXT_COMPONENT_TYPES[type].placeholder, {
    petType: petTypeTranslation
  });

  const onSubmit = (data: Record<string, string>) => {
    vars.newPet({ ...newPet, name: data[registerAs] });
    increaseFormPage();
  };

  return <FormText type={type} formOptions={{ register, handleSubmit, reset, formState }} onSubmit={onSubmit} title={title} placeholder={placeholder} />;
};
export default FormAddPetName;
